import React, { PureComponent, useReducer, Component } from "react";
import { Button, Card, Col, Form, notification, Row, Select, Tabs, Drawer } from "antd";
import { connect } from "react-redux";

import PageHeaderWrapper from "../../components/PageHeaderWrapper";
// import  from 'sz-react-utils'
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { hideLoader, showLoader } from "../../modules/actions";
import Request, { API_URL, LAPI_URL, MEDIA_URL } from "../../request";
import styles from "./styles.less";
import moment from "moment";
import Moment from "moment";
import _ from "lodash";
import { TumblrShareButton } from "react-share";

const Option = Select.Option;

const TabPane = Tabs.TabPane;
const config = {
  rules: [{ type: "object", required: true, message: "Please select time!" }],
};

// following variables needed for update country
let docLoaded = null;
let countryId = null;

@Form.create()
class AcceptPolicy extends Component {

  componentDidMount() {

  }

  handleButtonClick = (e) => {
    let data = {
      policyAccepted: Boolean(e.target.value)
    }
    this.props.handleSubmit(data)
  }

  render() {
    return (
      <Card>
        <Row style={{ textAlign: 'center' }}>
          <h4>Please carefully review and accept our company policies to complete your onboarding.</h4>
          <Button value={true} onClick={this.handleButtonClick}>Accept</Button>
        </Row>
      </Card>
    )
  }
}





@Form.create()
class UpdateProfile extends PureComponent {
  handleSubmit = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        dispatch(showLoader());
        let { error, msg, data } = await Request.updateProfile(values);
        dispatch(hideLoader());
        if (!error) {
          this.setState({ profileEdit: false });
          notification.success({
            message: "Profile Updated Successfully",
            description: msg,
          });
          this.sendProfileUpdateNotification()
          form.resetFields();
          this.getUserProfile();
        } else {
          notification.error({
            message: "Error Saving",
            description: msg,
          });
        }
      }
    });
  };

  sendProfileUpdateNotification = async () => {
    let response = await Request.sendProfileUpdateNotification();
    // console.log(response)
  }
  handleMaritalStatus = (data) => {
    if (data === "Married") {
      this.setState({ maritalStatus: true });
    } else {
      this.setState({ maritalStatus: false });
    }
  };
  openCert = (data, letter) => {
    if (data.policyAccepted === false) {
      this.setState({ showPoliciesDrawer: true, userDoc: data })
    } else {
      window.open(`${MEDIA_URL}${letter[0].url}`);
    }

  };

  handleSalaryUpdate = (data) => {
    if (data === "21000 or Less" && this.state.maritalStatus === true) {
      this.setState({ lessSalaryAndMarried: true });
    } else if (data === "21000 or Less" && this.state.maritalStatus === false) {
      this.setState({ lessSalaryAndMarried: false });
    } else {
      this.setState({ lessSalaryAndMarried: null });
    }
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();

    this.state = {
      file: null,
      userDoc: null,
      profileEdit: false,
      maritalStatus: false,
      lessSalaryAndMarried: null,
      showPoliciesDrawer: false,
      maritalStatuses: [],
      havePreviousExperience: false
    };
  }

  componentDidMount() {
    this.getUserProfile();
  }
  getMaritalStatusDetails = async () => {
    let params = {
      results: 1000,
      count: 1000
    }
    let response = await Request.getMaritalStatusDetails(params)
    let maritalStatuses = []
    _.each(response.data, (item) => {
      maritalStatuses.push({ _id: item.maritalStatus, display: item.maritalStatus })
    })
    this.setState({ maritalStatuses })
  }

  handleProfileEdit = () => {
    this.getMaritalStatusDetails()
    let { userDoc } = this.state;
    if (userDoc.maritalStatus === "Married") {
      this.setState({ maritalStatus: true });
    }
    if (
      userDoc.maritalStatus === "Married" &&
      userDoc.currentSalary === "21000 or Less"
    ) {
      this.setState({ lessSalaryAndMarried: true });
    }
    if (userDoc.havePreviousExperience) {
      this.setState({ havePreviousExperience: userDoc.havePreviousExperience }, () => {
        this.props.form.setFieldsValue({
          havePreviousExperience: userDoc && userDoc.havePreviousExperience,
          previousEmployerName: userDoc && userDoc.previousEmployerName,
          previousCompanyName: userDoc && userDoc.previousCompanyName,
          previousDuration: userDoc && userDoc.previousDuration,
          previousSalary: userDoc && userDoc.previousSalary,
          uanNumber: userDoc && userDoc.uanNumber,
          referenceName: userDoc && userDoc.referenceName,
          referenceNumber: userDoc && userDoc.referenceNumber,
        })
      })
    }

    this.setState({ profileEdit: true });
    setTimeout(() => {
      this.props.form.setFieldsValue({
        // ...userDoc,
        bankName: userDoc.bankDetails && userDoc.bankDetails.bankName,
        accountName: userDoc.bankDetails && userDoc.bankDetails.accountName,
        accountNumber: userDoc.bankDetails && userDoc.bankDetails.accountNumber,
        ifsc: userDoc.bankDetails && userDoc.bankDetails.ifsc,
        name: userDoc && userDoc.name,
        permanentAddress: userDoc && userDoc.permanentAddress,
        temporaryAddress: userDoc && userDoc.temporaryAddress,
        contactNo: userDoc && userDoc.contactNo,
        personalEmail: userDoc && userDoc.personalEmail,
        emergencyPhone: userDoc && userDoc.emergencyPhone,
        emergencyPerson: userDoc && userDoc.emergencyPerson,
        fatherName: userDoc && userDoc.fatherName,
        maritalStatus: userDoc && userDoc.maritalStatus,
        husbandWifeName: userDoc && userDoc.husbandWifeName,
        aadharNumber: userDoc && userDoc.aadharNumber,
        panNumber: userDoc && userDoc.panNumber,
        sibling: userDoc && userDoc.sibling,
        medicalIllness: userDoc && userDoc.medicalIllness,
        salary: userDoc && userDoc.salary,
        husbandWifeDob: userDoc && moment(userDoc.husbandWifeDob),
        childrenName: userDoc && userDoc.childrenName,
        childrenDob: userDoc && moment(userDoc.childrenDob),
        motherName: userDoc && userDoc.motherName,
        motherDob: userDoc && moment(userDoc.motherDob),
        fatherDob: userDoc && moment(userDoc.fatherDob),
        siblingName: userDoc && userDoc.siblingName,
        siblingDob: userDoc && moment(userDoc.siblingDob),
        highestQualification: userDoc && userDoc.highestQualification,
        universityorCollege: userDoc && userDoc.universityorCollege,
        emailPass: userDoc && userDoc.emailPass,
        laptopNumber: userDoc && userDoc.laptopNumber,
        laptopModel: userDoc && userDoc.laptopModel,
        mobileSerial: userDoc && userDoc.mobileSerial,
        otherOfficialAsset: userDoc && userDoc.otherOfficialAsset,
        aadharCard: userDoc && userDoc.aadharCard,
        panCard: userDoc && userDoc.panCard,
        academicCertificates: userDoc && userDoc.academicCertificates,
        experienceCert: userDoc && userDoc.experienceCert,
        salarySlip: userDoc && userDoc.salarySlip,
        medicalIllnessCert: userDoc && userDoc.medicalIllnessCert,
        bankPassbook: userDoc && userDoc.bankPassbook,
        photo: userDoc && userDoc.photo,
        dob: userDoc && moment(userDoc.dob),
        previousExperienceCert: userDoc && userDoc.previousExperienceCert
      })
    }, 500)
  };

  async getUserProfile() {
    let { data } = await Request.getUserProfileByUserId();
    if (data) {
      if (data.userImage && data.userImage.url) {
        data.userImage.url = MEDIA_URL + data.userImage.url;
        this.props.form.setFieldsValue({ userImage: [data.userImage] });
      }
      this.setState({ userDoc: data });
    }
  }

  render() {
    const {
      userDoc = null,
      profileEdit,
      maritalStatus,
      lessSalaryAndMarried,
      showPoliciesDrawer,
      havePreviousExperience
    } = this.state;

    const {
      form: { getFieldDecorator },
    } = this.props;

    let inputTypes = {
      fields: [
        {
          label: "Profile Picture",
          key: "userImage",
          type: "file",
          limit: 1,
          defaultFileList: [],
          required: true,
          width: 300,
        },
      ],
    };

    let BankDetailInputTypes = {
      fields: [
        {
          label: "Bank Name",
          key: "bankName",
          type: "text",
          required: true,
        },
        {
          label: "Bank Account No.",
          key: "accountNumber",
          type: "text",
          required: true,
        },
        {
          label: "IFSC Code",
          key: "ifsc",
          type: "text",
          required: true,
        },
        {
          label: "Name in Account",
          key: "accountName",
          type: "text",
          required: true,
        },
      ],
    };

    let generalInformationInputTypes = {
      fields: [
        {
          label: "Name",
          type: "text",
          key: "name",
          required: true,
        },
        {
          label: "Permanent Address",
          type: "address",
          key: "permanentAddress",
          required: true,
        },
        {
          label: "Current Address",
          type: "address",
          key: "temporaryAddress",
          required: true,
        },
        {
          label: "Personal Contact Number",
          type: "text",
          key: "contactNo",
          required: true,
        },
        {
          label: "Personal Email Id",
          type: "email",
          key: "personalEmail",
          required: true,
        },
        {
          label: "Emergency Number",
          type: "text",
          key: "emergencyPhone",
          required: true,
        },
        {
          label: `Emergency Contact Person`,
          type: "text",
          key: "emergencyPerson",
          required: true,
        },
        {
          label: "Date of Birth",
          type: "date",
          key: "dob",
          required: true,
        },
        {
          label: `Father's Name`,
          type: "text",
          key: "fatherName",
          required: true,
        },
        {
          label: "Marital Status",
          type: "select",
          key: "maritalStatus",
          options: this.state.maritalStatuses,
          required: true,
          onChange: (v) => {
            this.props.form.setFieldsValue({ maritalStatus: v });
            this.handleMaritalStatus(v);
          },
        },
        {
          label: "Husband/Wife Name",
          type: "text",
          key: "husbandWifeName",
          hidden: !maritalStatus,
          required: maritalStatus,
        },
        {
          label: "Aadhar Number",
          type: "text",
          key: "aadharNumber",
          required: true,
        },
        {
          label: "Pan Number",
          type: "text",
          key: "panNumber",
          required: true,
        },
        {
          label: "Any Sibling",
          type: "select",
          key: "sibling",
          options: ["Yes", "No"],
          required: true,
          onChange: v => {
            this.props.form.setFieldsValue({ sibling: v })
          }
        },
        {
          label: "Any Medical Illness",
          type: "text",
          key: "medicalIllness",
          required: true,
        },
        {
          label: "Current Salary",
          type: "select",
          required: true,
          key: "salary",
          options: ["21000 or Less", "More than 21000"],
          onChange: (v) => {
            this.props.form.setFieldsValue({ salary: v });
            this.handleSalaryUpdate(v);
          },
        },
        {
          label: "Husband/Wife DOB",
          type: "date",
          key: "husbandWifeDob",
          hidden: !lessSalaryAndMarried,
          required: lessSalaryAndMarried,
        },
        {
          label: "Children Name",
          prefixComp: "Children Details (if Any)",
          type: "text",
          key: "childrenName",
          hidden: !lessSalaryAndMarried,
        },
        {
          label: "Children DOB",
          type: "date",
          key: "childrenDob",
          hidden: !lessSalaryAndMarried,
        },
        {
          label: `Mother's Name`,
          type: "text",
          key: "motherName",
          hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
          required:
            !lessSalaryAndMarried === null ? true : !lessSalaryAndMarried,
        },
        {
          label: `Mother's DOB`,
          type: "date",
          key: "motherDob",
          hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
          required:
            !lessSalaryAndMarried === null ? true : !lessSalaryAndMarried,
        },

        {
          label: `Father's DOB`,
          type: "date",
          key: "fatherDob",
          hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
          required:
            !lessSalaryAndMarried === null ? true : !lessSalaryAndMarried,
        },
        {
          label: "Sibling Name",
          prefixComp: "Sibling Details (if Any)",
          key: "siblingName",
          hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
        },
        {
          label: "Sibling DOB",
          type: "date",
          key: "siblingDob",
          hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
        },
      ],
    };

    let academicDetailInputTypes = {
      fields: [
        {
          label: "Highest Qualification",
          type: "text",
          key: "highestQualification",
          required: true,
        },
        {
          label: "University/College",
          type: "text",
          key: "universityorCollege",
          required: true,
        },
      ],
    };

    let previousExpierenceInputTypes = {
      fields: [
        {
          label: 'Do You Have Experience?',
          type: 'switch',
          key: 'havePreviousExperience',
          onChange: v => {
            this.props.form.setFieldsValue({ havePreviousExperience: v })
            this.setState({ havePreviousExperience: v })
          }
        },
        {
          label: "Last Employer Name",
          type: "text",
          key: "previousEmployerName",
          hidden: !havePreviousExperience,
          required: havePreviousExperience
        },
        {
          label: "Last Company Name",
          type: "text",
          key: "previousCompanyName",
          hidden: !havePreviousExperience,
          required: havePreviousExperience
        },
        {
          label: "Duration",
          type: "text",
          key: "previousDuration",
          hidden: !havePreviousExperience,
          required: havePreviousExperience
        },
        {
          label: "Last Salary",
          type: "text",
          key: "previousSalary",
          hidden: !havePreviousExperience,
          required: havePreviousExperience
        },
        {
          label: "UAN Number",
          type: "text",
          key: "uanNumber",
          hidden: !havePreviousExperience,
        },
        {
          label: 'Reference Name',
          type: 'text',
          key: 'referenceName',
          hidden: !havePreviousExperience,
          required: havePreviousExperience
        },
        {
          label: 'Reference Number',
          type: 'text',
          key: 'referenceNumber',
          hidden: !havePreviousExperience,
          required: havePreviousExperience
        }
      ],
    };

    let currentEmploymentInputTypes = {
      fields: [
        {
          label: "Official Email Password",
          type: "text",
          key: "emailPass",
          required: true,
        },
        {
          label: "Laptop Serial Number",
          type: "text",
          key: "laptopNumber",
          required: true,
        },
        {
          label: "Laptop Model",
          type: "text",
          key: "laptopModel",
          required: true,
        },
        {
          label: 'Official Mobile Serial',
          type: 'text',
          key: 'mobileSerial',
          required: true,
        },
        {
          label: "Any Other Asset",
          type: "text",
          key: "otherOfficialAsset",
          required: true,
        },
      ],
    };

    let documentsRequiredInputTypes = {
      fields: [
        {
          label: "Aadhar Card",
          type: "file",
          key: "aadharCard",
          required: true,
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "Pan Card",
          type: "file",
          key: "panCard",
          required: true,
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "All Academic Certificates",
          type: "file",
          key: "academicCertificates",
          required: true,
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "Previous Experience Letter",
          type: "file",
          key: "previousExperienceCert",
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "3 Months Salary Proof",
          type: "file",
          key: "salarySlip",
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "Medical Illness Certificate",
          type: "file",
          key: "medicalIllnessCert",
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "Bank Passbook",
          type: "file",
          key: "bankPassbook",
          required: true,
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "Passport Size Photo",
          type: "file",
          key: "photo",
          required: true,
          limit: 1,
          defaultFileList: [],
        },
      ],
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 10 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 30 },
        sm: { span: 16 },
        md: { span: 12 },
      },
    };

    const submitFormLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 10, offset: 7 },
        md: { span: 12, offset: 8 },
      },
    };

    return (
      <PageHeaderWrapper title={"My Profile"}>
        {profileEdit ? (
          <Card>
            {userDoc ? (
              <div>
                <Row>
                  <Col span={12}>
                    <Card>
                      {userDoc.userImage && userDoc.userImage.url ? (
                        <div className={styles.profileDiv}>
                          <img
                            src={userDoc.userImage.url}
                            className={styles.profileImage}
                          />
                        </div>
                      ) : null}
                      <Form
                        onSubmit={this.handleSubmit}
                        style={{ marginTop: 8 }}
                      >
                        <div>
                          <GetAllFormFields
                            formItemLayout={{
                              wrapperCol: { span: 30, align: "center" },
                            }}
                            apiurl={LAPI_URL}
                            inputSchema={inputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                          />
                          <Card
                            title="Bank Details"
                            style={{ marginTop: "40px", textAlign: "center" }}
                          >
                            <GetAllFormFields
                              apiurl={LAPI_URL}
                              inputSchema={BankDetailInputTypes}
                              refresh={this.refreshFxn}
                              getFieldDecorator={getFieldDecorator}
                            />
                          </Card>
                          <Card
                            title="Previous Experience"
                            style={{ marginTop: "40px", textAlign: "center" }}
                          >
                            <GetAllFormFields
                              apiurl={LAPI_URL}
                              inputSchema={previousExpierenceInputTypes}
                              refresh={this.refreshFxn}
                              getFieldDecorator={getFieldDecorator}
                            />
                          </Card>
                          <Card
                            title="Current Employment Details"
                            style={{ marginTop: "40px", textAlign: "center" }}
                          >
                            <GetAllFormFields
                              apiurl={LAPI_URL}
                              inputSchema={currentEmploymentInputTypes}
                              refresh={this.refreshFxn}
                              getFieldDecorator={getFieldDecorator}
                            />
                          </Card>
                          <Card
                            title="Academic Details"
                            style={{ marginTop: "40px", textAlign: "center" }}
                          >
                            <GetAllFormFields
                              apiurl={LAPI_URL}
                              inputSchema={academicDetailInputTypes}
                              refresh={this.refreshFxn}
                              getFieldDecorator={getFieldDecorator}
                            />
                          </Card>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              type="primary"
                              htmlType="submit"
                              style={{ marginTop: 10 }}
                              loading={this.props.loading}
                            >
                              UPDATE PROFILE
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card>
                      <Form>
                        <Card
                          title="General Information"
                          style={{ textAlign: "center" }}
                        >
                          <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={generalInformationInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                          />
                        </Card>
                        <Card
                          title="Upload Documents"
                          style={{ textAlign: "center", marginTop: "40px" }}
                        >
                          <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={documentsRequiredInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                          />
                        </Card>
                      </Form>
                    </Card>
                  </Col>
                </Row>
              </div>
            ) : null}
          </Card>
        ) : (
          <Card>
            {userDoc ? (
              <div>
                <Row>
                  <Col span={12}>
                    {userDoc.userImage && userDoc.userImage.url ? (
                      <div className={styles.profileDiv}>

                        <img
                          src={userDoc.userImage.url}
                          className={styles.profileImage}
                        />
                      </div>
                    ) : null}
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                      <div className={styles.myForm}>
                        <div style={{ textAlign: "center" }}>
                          {userDoc.editedByUser ? null : (
                            <Button
                              onClick={this.handleProfileEdit}
                              style={{ marginTop: 10 }}
                            >
                              EDIT PROFILE
                            </Button>
                          )}
                        </div>
                      </div>
                    </Form>
                    <Card style={{ marginTop: 11, marginRight: 11 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                Bank Details
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Bank Name</td>
                            <td>
                              {userDoc.bankDetails &&
                                userDoc.bankDetails.bankName
                                ? userDoc.bankDetails.bankName
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Account No</td>
                            <td>
                              {userDoc.bankDetails &&
                                userDoc.bankDetails.accountNumber
                                ? userDoc.bankDetails.accountNumber
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Account Name</td>
                            <td>
                              {userDoc.bankDetails &&
                                userDoc.bankDetails.accountName
                                ? userDoc.bankDetails.accountName
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>IFSC Code</td>
                            <td>
                              {userDoc.bankDetails && userDoc.bankDetails.ifsc
                                ? userDoc.bankDetails.ifsc
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                    <Card style={{ marginTop: 11, marginRight: 11 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                Previous Experience
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Last Employer Name</td>
                            <td>
                              {userDoc.previousEmployerName &&
                                userDoc.previousEmployerName
                                ? userDoc.previousEmployerName
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Last Company Name</td>
                            <td>
                              {userDoc.previousCompanyName &&
                                userDoc.previousCompanyName
                                ? userDoc.previousCompanyName
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Duration of Last Employmentship</td>
                            <td>
                              {userDoc.previousDuration &&
                                userDoc.previousDuration
                                ? userDoc.previousDuration
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Last Salary</td>
                            <td>
                              {userDoc.previousSalary && userDoc.previousSalary
                                ? userDoc.previousSalary
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                    <Card style={{ marginTop: 11, marginRight: 11 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                Current Employment Details
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Official Email</td>
                            <td>
                              {userDoc.email && userDoc.email
                                ? userDoc.email
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Official Phone Number</td>
                            <td>
                              {userDoc.userMobile && userDoc.userMobile
                                ? userDoc.userMobile
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Laptop Serial Number</td>
                            <td>
                              {userDoc.laptopNumber && userDoc.laptopNumber
                                ? userDoc.laptopNumber
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Laptop Model</td>
                            <td>
                              {userDoc.laptopModel && userDoc.laptopModel
                                ? userDoc.laptopModel
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Any Other Official Asset</td>
                            <td>
                              {userDoc.otherOfficialAsset &&
                                userDoc.otherOfficialAsset
                                ? userDoc.otherOfficialAsset
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                    {/* Academic Details */}
                    <Card style={{ marginTop: 11, marginRight: 11 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                Academic Details
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Highest Qualification</td>
                            <td>
                              {userDoc.highestQualification &&
                                userDoc.highestQualification
                                ? userDoc.highestQualification
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>University/College</td>
                            <td>
                              {userDoc.universityorCollege &&
                                userDoc.universityorCollege
                                ? userDoc.universityorCollege
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                    {/* OnBoarding Documents */}
                    <Card style={{ marginTop: 11, marginRight: 11 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                OnBoarding Documents
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Appointment Letter</td>
                            <td>
                              {userDoc && userDoc.appointmentCert && userDoc.appointmentCert.length > 0 ? (
                                <Button
                                  icon="download"
                                  title="Download Appointment Letter"
                                  onClick={() => {
                                    this.openCert(userDoc, userDoc.appointmentCert);
                                  }}
                                />
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Employee Agreement</td>
                            <td>
                              {userDoc && userDoc.employeeAgreementCert && userDoc.employeeAgreementCert.length > 0 ? (
                                <Button
                                  icon="download"
                                  title="Download Employee Agreement"
                                  onClick={() => {
                                    this.openCert(userDoc,
                                      userDoc.employeeAgreementCert
                                    );
                                  }}
                                />
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Appraisal Letter</td>
                            <td>
                              {userDoc && userDoc.appraisalCert && userDoc.appraisalCert.length > 0 ? (
                                <Button
                                  icon="download"
                                  title="Download Appraisal Letter"
                                  onClick={() => {
                                    this.openCert(
                                      userDoc, userDoc.appraisalCert
                                    );
                                  }}
                                />
                              ) : null}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                    {/* Exit Documents */}
                    <Card style={{ marginTop: 11, marginRight: 11 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                Exit Documents
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Experience Letter</td>
                            <td>
                              {userDoc && userDoc.experienceCert && userDoc.experienceCert.length > 0 ? (
                                <Button
                                  icon="download"
                                  title="Download Experience Letter"
                                  onClick={() => {
                                    this.openCert(userDoc, userDoc.experienceCert);
                                  }}
                                />
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Relieving Certificate</td>
                            <td>
                              {userDoc && userDoc.relievingCert && userDoc.relievingCert.length > 0 ? (
                                <Button
                                  icon="download"
                                  title="Download Releiving Letter"
                                  onClick={() => {
                                    this.openCert(userDoc, userDoc.relievingCert);
                                  }}
                                />
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>No Due Certificate</td>
                            <td>
                              {userDoc && userDoc.noDueCert && userDoc.noDueCert.length > 0 ? (
                                <Button
                                  icon="download"
                                  title="Download No Due Certificate"
                                  onClick={() => {
                                    this.openCert(userDoc, userDoc.noDueCert);
                                  }}
                                />
                              ) : null}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card>
                      <span className={styles.welcomeHeader}>
                        Welcome {userDoc.name}!
                      </span>
                    </Card>
                    <Card style={{ marginTop: 20 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                General Information
                              </span>
                              <p>
                                (All the Information must be as per the Aadhar
                                Card)
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>Name</td>
                            <td>
                              {userDoc.name && userDoc.name ? userDoc.name : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Permanent Address with PIN</td>
                            <td>{userDoc.permanentAddress}</td>
                          </tr>
                          <tr>
                            <td>Currently Residing Address with PIN</td>
                            <td>{userDoc.temporaryAddress}</td>
                          </tr>
                          <tr>
                            <td>Personal Contact Number</td>
                            <td>{userDoc.contactNo}</td>
                          </tr>
                          <tr>
                            <td>Personal Email ID</td>
                            <td>{userDoc.personalEmail}</td>
                          </tr>
                          <tr>
                            <td>Emergency Contact Number</td>
                            <td>{userDoc.emergencyPhone}</td>
                          </tr>
                          <tr>
                            <td>Emergency Contact Person Name</td>
                            <td>{userDoc.emergencyPerson}</td>
                          </tr>
                          <tr>
                            <td>Relation with Emergency Contact Person</td>
                            <td>{userDoc.husbandWifeName}</td>
                          </tr>
                          <tr>
                            <td>Date of Birth</td>
                            <td>
                              {userDoc.dob && userDoc.dob
                                ? moment(userDoc.dob).format("ll")
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td>Father's Name</td>
                            <td>
                              {userDoc.fatherName && userDoc.fatherName
                                ? userDoc.fatherName
                                : "NA"}
                            </td>
                          </tr>

                          <tr>
                            <td>Marital Status</td>
                            <td>
                              {userDoc.maritalStatus && userDoc.maritalStatus
                                ? userDoc.maritalStatus
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Husband/Wife Name</td>
                            <td>
                              {userDoc.husbandWifeName &&
                                userDoc.husbandWifeName
                                ? userDoc.husbandWifeName
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Any Medical Illness</td>
                            <td>
                              {userDoc.medicalIllness && userDoc.medicalIllness
                                ? userDoc.medicalIllness
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Aadhar Card Number</td>
                            <td>
                              {userDoc.aadharNumber && userDoc.aadharNumber
                                ? userDoc.aadharNumber
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Pan Card Number</td>
                            <td>
                              {userDoc.panNumber && userDoc.panNumber
                                ? userDoc.panNumber
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Husband/Wife Date of Birth</td>
                            <td>
                              {userDoc.husbandWifeDob &&
                                userDoc.husbandWifeDob
                                ? moment(userDoc.husbandWifeDob).format("ll")
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Children Name</td>
                            <td>
                              {userDoc.childrenName && userDoc.childrenName
                                ? userDoc.childrenName
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Children Date of Birth</td>
                            <td>
                              {userDoc.childrenDob && userDoc.childrenDob
                                ? moment(userDoc.childrenDob).format("ll")
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Mother's Name</td>
                            <td>
                              {userDoc.motherName && userDoc.motherName
                                ? userDoc.motherName
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Mother's Date of Birth</td>
                            <td>
                              {userDoc.motherDob && userDoc.motherDob
                                ? moment(userDoc.motherDob).format("ll")
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Father's Date of Birth</td>
                            <td>
                              {userDoc.fatherDob && userDoc.fatherDob
                                ? userDoc.fatherDob
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Sibling Name</td>
                            <td>
                              {userDoc.siblingName && userDoc.siblingName
                                ? userDoc.siblingName
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Sibling Date of Birth</td>
                            <td>
                              {userDoc.siblingDob && userDoc.siblingDob
                                ? moment(userDoc.siblingDob).format("ll")
                                : "NA"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                    <Card style={{ marginTop: 20 }}>
                      <table className={styles.table1}>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <span className={styles.profileHeader}>
                                OnBoarding Details
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Employee ID</td>
                            <td>
                              {userDoc.empId && userDoc.empId
                                ? userDoc.empId
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Joining Date</td>
                            <td>
                              {userDoc.dateOfJoining && userDoc.dateOfJoining
                                ? moment(userDoc.dateOfJoining).format("ll")
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Designation</td>
                            <td>
                              {userDoc.designation && userDoc.designation
                                ? userDoc.designation
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Salary Offered</td>
                            <td>
                              {userDoc.joiningSalary && userDoc.joiningSalary
                                ? userDoc.joiningSalary
                                : "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td>Shift Timing</td>
                            <td>
                              {userDoc.shiftTiming && userDoc.shiftTiming
                                ? userDoc.shiftTiming
                                : "NA"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Card>
                  </Col>
                </Row>
              </div>
            ) : null}
          </Card>
        )}

        <Drawer
          title="Accept Policy"
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              showPoliciesDrawer: false
            })
          }}
          visible={showPoliciesDrawer}
          width={400}>
          <div>
            <AcceptPolicy
              loading={this.props.loading}
              handleSubmit={
                async (values) => {
                  userDoc.policyAccepted = values.policyAccepted;

                  let response = await Request.updateProfile(userDoc);
                  if (!response.error) {
                    notification.success({
                      message: 'Policy Accepted'
                    })
                    this.setState({
                      showPoliciesDrawer: false
                    })
                  }
                }
              }
            />
          </div>
        </Drawer>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateProfile);
